<template>
  <div style="margin-bottom:15px;" :data-vv-scope="item.id">
    <div>
      <label v-bind:style="{color: item.header.textColor,
                                      fontSize: item.header.font.fontSize + 'px',
                                      fontWeight: item.header.font.fontWeight,
                                      fontStyle: item.header.font.fontStyle}">
        {{item.header.text}} {{item.isRequired && (item.type !='label' && item.type !='html' ) ? '*' : ''}}
      </label>
    </div>
    <div>
      <component :is="item.type" :item="item" />
    </div>
    <div v-for="(child) in item.children" :key="child.id" style="margin-left:15px;margin-top:5px">
      <single-survey :item="child" />
    </div>
  </div>

</template>
<script>
import SurveyLabel from './SurveyLabel'
import SurveyInput from './SurveyInput'
import SurveyCheckbox from './SurveyCheckbox'
import SurveyRadio from './SurveyRadio'
import SurveyRadioButton from './SurveyRadioButton'
import SurveyCheckboxButton from './SurveyCheckboxButton'
import SurveyTextarea from './SurveyTextarea'
import SurveyNumber from './SurveyNumber'
import SurveyDate from './SurveyDate'
import SurveyDateTime from './SurveyDateTime'
import SurveyHtml from './SurveyHtml'
export default {
  name: 'single-survey',
  props: ['item'],
  components: {
    'survey-label': SurveyLabel,
    'survey-input': SurveyInput,
    'survey-checkbox': SurveyCheckbox,
    'survey-radio': SurveyRadio,
    'survey-radio-button': SurveyRadioButton,
    'survey-checkbox-button': SurveyCheckboxButton,
    'survey-textarea': SurveyTextarea,
    'survey-number': SurveyNumber,
    'survey-date': SurveyDate,
    'survey-datetime': SurveyDateTime,
    'survey-html': SurveyHtml
  },
  inject: ['parentValidator'],
  provide() {
    return { parentValidator: this.parentValidator }
  },
  data() {
    return {}
  },
  created() {}
}
</script>